import {
  takeLatest,
  take,
  select,
  put,
  call,
  race,
  delay
} from 'redux-saga/effects';
import { NOTIFY, INITIATE_CLOSE, CLOSED } from './constants';
import { getIsOpen } from './selectors';
import { set, initiateClose } from './actions';

const MINIMUM_OPEN_DURATION = 500;
let openTimestamp = null; // When the notification was opened in ms since the UNIX epoch

const calculateTimeLeft = () => {
  const openDuration = Date.now() - openTimestamp;
  const timeLeft = MINIMUM_OPEN_DURATION - openDuration;
  return timeLeft > 0 ? timeLeft : 0;
};

const setOpenTimestamp = timestamp => {
  openTimestamp = timestamp;
};

function* setNotification(notification) {
  yield call(setOpenTimestamp, Date.now());
  yield put(set(notification));
  // Schedule a close request if a duration bigger than 0 is set,
  if (notification.duration > 0) {
    // TODO: Refactor to genereator, is used in queueNotification as well.
    const { timePassed } = yield race({
      timePassed: delay(notification.duration),
      closeInitiated: take(INITIATE_CLOSE)
    });
    if (timePassed) {
      yield put(initiateClose());
    }
  }
}

function* queueNotification(notification) {
  const { timePassed } = yield race({
    timePassed: delay(calculateTimeLeft()),
    closeInitiated: take(INITIATE_CLOSE)
  });
  if (timePassed) {
    yield put(initiateClose());
  }
  yield take(CLOSED);
  yield setNotification(notification);
}

function* enqueueNotification(action) {
  const notification = action.payload;
  const isOpen = yield select(getIsOpen);

  if (isOpen) {
    yield call(queueNotification, notification);
  } else {
    yield call(setNotification, notification);
  }
}

export default [takeLatest(NOTIFY, enqueueNotification)];
